<script lang="ts">
	// Fixed dimensions per requirement
	export let width: number = 130;
	export let height: number = 80;
	export let className: string = "";

	// Font Awesome solid icon classes (overlaid on top of the SVG)
	export let earthClass: string = "fa-solid fa-earth-americas"; // or fa-earth-asia
	export let planeClass: string = "fa-solid fa-plane";

	// Optional small bottom text (e.g., year)
	export let showBottomText: boolean = true;

  export let distanceText: string = "40,075 km";
</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
	<svg
		{width}
		{height}
		viewBox="0 0 130 80"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="Around the World passport stamp"
		class={className}
	>
		<title>Around the World Passport Stamp</title>

		<defs>
			<!-- Top arc path for curved title on inner oval -->
			<path id="textArcTop" d="M 13 40 A 52 28 0 0 1 117 40" />
			<!-- Bottom arc path for small optional text -->
			<path id="textArcBottom" d="M 13 40 A 52 34 0 0 0 117 40" />
		</defs>

		<!-- Double-oval border with scalloped micro-notches -->
		<!-- Outer oval -->
		<ellipse cx="65" cy="40" rx="62" ry="37" fill="none" stroke="#000" stroke-width="1.8" />
		<!-- Inner oval (thin rule) -->
		<ellipse cx="65" cy="40" rx="52" ry="28" fill="none" stroke="#000" stroke-width="0.9" opacity="0.95" />
		<!-- Scalloped micro-notches (beaded dash around oval) -->
		<ellipse cx="65" cy="40" rx="48" ry="24" fill="none" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.4 4" opacity="0.85" />

		<!-- Subtle central panel to suggest vintage ink fill (black-only via opacity) -->
		<ellipse cx="65" cy="40" rx="44" ry="22" fill="#000" opacity="0.06" />

		<!-- Elliptical orbit path encircling the center globe -->
		<ellipse cx="65" cy="40" rx="36" ry="18" fill="none" stroke="#000" stroke-width="1.2" stroke-dasharray="4 4" opacity="0.9" />

		<!-- Curved title -->
		<text fill="#000" font-size="9.5" font-weight="700" text-anchor="middle" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.5;">
			<textPath href="#textArcTop" startOffset="50%">AROUND THE WORLD</textPath>
		</text>

		<!-- Optional small bottom curved text -->
		{#if showBottomText}
			<text fill="#000" font-size="6.5" font-weight="500" text-anchor="middle" opacity="0.85" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.4;">
				<textPath href="#textArcBottom" startOffset="50%">{distanceText}</textPath>
			</text>
		{/if}
	</svg>

	<!-- Font Awesome icon overlays (solid, pure black) -->
	<!-- Earth icon centered on the stamp -->
	<div class="absolute" style="top:50%;left:50%;transform:translate(-50%,-50%);color:#000;">
		<i class={earthClass} style="font-size:24px;line-height:1;color:#000;opacity:0.95;"></i>
	</div>

	<!-- Plane icon positioned along the orbit path (top-right quadrant) -->
	<div class="absolute" style="top:27px;left:91px;transform:translate(-50%,-50%);color:#000;">
		<i class={planeClass} style="font-size:14px;line-height:1;color:#000;opacity:0.78;"></i>
	</div>
</div>
